/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'report-errors-over-http',
  title: 'Report errors over HTTP',
  category: 'SDKs & API',
  summary:
    'No SDK for your stack? Send errors to PulseWatch as JSON with a single HTTP request. The fields, the limits and a curl example.',
  keywords: ['API', 'HTTP', 'curl', 'JSON', 'ingest', 'webhook', 'custom SDK', 'error event'],
};

export const loadComponent = () => import('./report-errors-over-http.component').then((m) => m.ReportErrorsOverHttpArticleComponent);
